import { apiService } from './api'
import { useAuthStore } from '@/stores/auth'

export const customersApi = {
  // Get all customers for the business
  async getCustomers(params = {}) {
    const response = await apiService.get('/customers', params)
    return response // API service already returns response.data
  },

  // Get customer by ID
  async getCustomer(customerId) {
    const response = await apiService.get(`/customers/${customerId}`)
    return response // API service already returns response.data
  },

  // Create new customer
  async createCustomer(customerData) {
    const response = await apiService.post('/customers', customerData)
    return response // API service already returns response.data
  },

  // Update customer
  async updateCustomer(customerId, customerData) {
    const response = await apiService.put(`/customers/${customerId}`, customerData)
    return response // API service already returns response.data
  },

  // Delete customer
  async deleteCustomer(customerId) {
    const response = await apiService.delete(`/customers/${customerId}`)
    return response // API service already returns response.data
  },

  // Search customers
  async searchCustomers(query) {
    const response = await apiService.get(`/customers/search?q=${encodeURIComponent(query)}`)
    return response // API service already returns response.data
  },

  // Import customers from file
  async importCustomers(file, options = {}) {
    try {
      const authStore = useAuthStore()
      const businessId = authStore.businessId
      
      console.log('Import debug:', {
        businessId,
        user: authStore.user,
        business: authStore.business,
        token: !!authStore.token
      })
      
      if (!businessId) {
        console.error('Business ID not available:', {
          userBusinessId: authStore.user?.business_id,
          businessFromStore: authStore.business,
          computedBusinessId: authStore.businessId
        })
        throw new Error('No business ID available. Please refresh the page and try again.')
      }

      const formData = new FormData()
      formData.append('file', file)
      formData.append('business_id', businessId)
      formData.append('options', JSON.stringify(options))

      // Use the same base URL as the API service
      const apiBaseUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000/api'
      const importUrl = `${apiBaseUrl}/customers/bulk-import`
      
      console.log('Environment check:', {
        viteApiUrl: import.meta.env.VITE_API_URL,
        apiBaseUrl,
        importUrl
      })

      const response = await fetch(importUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authStore.token}`
        },
        body: formData
      })

      if (!response.ok) {
        let errorMessage = 'Import failed'
        try {
          const errorData = await response.json()
          errorMessage = errorData.message || errorMessage
        } catch (e) {
          errorMessage = `HTTP ${response.status}: ${response.statusText}`
        }
        throw new Error(errorMessage)
      }

      return await response.json()
    } catch (error) {
      console.error('Error importing customers:', error)
      throw error
    }
  }
}

export default customersApi
